import Vue from "vue";
import { NIPIGE_BASE_URL } from "@/config/index";
import * as io from "socket.io-client";
import VueSocketIO from "vue-socket.io";

export default {
  methods: {
    initSocket() {
      let currentUser = null;
      const sessionUser = sessionStorage.getItem("userLogin");
      if (sessionUser) {
        try {
          currentUser = JSON.parse(sessionUser);
        } catch (error) {
          currentUser = null;
        }
      }

      if (currentUser && currentUser.token) {
        const socketoptions = {
          path: "/notification/ws",
          transports: ["websocket", "polling"],
          query: `token=${currentUser.token}`,
          reconnection: true,
          reconnectionDelay: 1000,
          reconnectionDelayMax: 5000,
          reconnectionAttempts: 10,
        };
        Vue.use(
          new VueSocketIO({
            debug: true,
            connection: io(NIPIGE_BASE_URL, socketoptions),
          })
        );
      }
    },
  },
};
